import { ListItem, UnorderedList } from 'evergreen-ui';
import React, { memo } from 'react';
import { Referral, ReferralConsideration } from '..';

type Props = {
    referral: Referral
}

const labels: Record<ReferralConsideration, string> = {
    CPI_Training: 'CPI Training',
    Clinic_based: 'Services must be provided in a clinic setting',
    Escalation: 'Escalation',
    None: 'None',
    Out_of_Service_Area: 'Out of Service Area - Client willing to travel into service area, services cannot be provided in client home',
    Provider_Request: 'Provider Request',
    Siblings: 'Client has a sibling that is also receiving services; family prefers to place with the same provider',
    Translation_Services: 'Translation services can be used in-session'
}

export const ConsiderationRenderer = memo(function ConsiderationRenderer({ referral }: Props) {
    const { referralConsiderations } = referral;

    if (referralConsiderations.length === 0) {
        return 'None';
    }

    // on provider side, we only display following 3 values if selected, the rest should not be shown
    const displayableConsiderations = [ReferralConsideration.Clinic_based, ReferralConsideration.Siblings, ReferralConsideration.Translation_Services];

    const toDisplayConsiderations = displayableConsiderations.filter((c) => referralConsiderations.includes(c));

    return (
        <UnorderedList size={ 500 }>
            { toDisplayConsiderations.map((value, key) => (
                <ListItem key={ key }>{ labels[value] }</ListItem>
            )) }
        </UnorderedList>
    )
});
